import React, { Component } from "react";
import axios from "axios";
import ApiV2 from "./apiV2";
import { Card, Container, Row, Button } from "react-bootstrap";
import Resizer from "react-image-file-resizer";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from 'uuid';

export default class ImageUpload extends Component {
  constructor(props) {
    super(props);
    const imageUrl = this.props.imageUrl ? this.props.imageUrl : "";
    this.state = {
      file: null,
      fields: {},
      url: "",
      fileName: "",
      imageUrl
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.fileName !== this.state.fileName) {
      if (this.state.fileName !== "") {
        const data = await ApiV2.getPresignedPostUrl(this.state.fileName);
        this.setState({
          fields: data.fields,
          url: data.url
        });
      }
    }
  }

  onFormSubmit = async () => {
    const formData = new FormData();
    Object.keys(this.state.fields).forEach(fieldKey => {
      formData.append(fieldKey, this.state.fields[fieldKey]);
    });
    formData.append("file", this.state.file);
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };

    try {
      await axios.post(this.state.url, formData, config);
      await ApiV2.setPublicAcl(this.state.fileName);
      const { imageUrl } = await ApiV2.getImageUrl(this.state.fileName);

      if (this.props.photoType === 'PROFILE') {
        await ApiV2.setUserPhotoUrl(imageUrl); // updates custom:photoURL in Cognito
        await ApiV2.uploadProfilePic(imageUrl); // updates photoURL attribute in dynamoDB Users table
      } else if (this.props.photoType === 'SPOT'){
        await ApiV2.setSpotPhoto(this.props.idPrefix, imageUrl);
      }
      this.props.notifyInfo(`Successfully updated ${this.props.photoType.toLowerCase()} photo`)
      // this.props.setImageUrl(imageUrl);
      // this.setState({
      //   imageUrl
      // });
    } catch (e) {
        console.log("Error uploading file" + JSON.stringify(e));
      this.props.notifyFailure("Error uploading file", e);
    }
  };

  onChange = e => {

    if (this.props.photoType === 'PROFILE'){
      Resizer.imageFileResizer(
        e.target.files[0],
        500, //maxWidth
        500, //maxHeight
        "JPEG",
        100,
        0,
        uri => {
          this.setState({
            file: uri
          });
        },
        "blob"
      );
    } else {
      this.setState({file: e.target.files[0]})
    }

    const originalFileNameArray = e.target.files[0].name.split(".");
    const photoPrefix = `${this.props.photoType}-${this.props.idPrefix}`
    const idSuffix = uuidv4().slice(0,8);
    const newFileName = `${photoPrefix}-${idSuffix}.${originalFileNameArray[originalFileNameArray.length - 1]}`;
    this.setState({
      fileName: newFileName
    });
  };

  renderPicture() {

    if (!this.state.imageUrl){
        return (
            <>Select photo to upload</>
        )
    }
    return (
      <Card key={this.state.imageUrl} style={{ width: "320px" }}>
        <Card.Img variant="top" src={this.state.imageUrl} />
      </Card>
    );
  }

  render() {
    return (
      <Container>
        <Row className="d-flex justify-content-center">
          <Card>
            {this.renderPicture()}
            <input type="file" name="myImage" onChange={this.onChange} />
            <Button
              type="submit"
              onClick={async () => {
                await this.onFormSubmit();
                this.props.onHide();
              }}
            >
              Submit
            </Button>
          </Card>
        </Row>
      </Container>
    );
  }
}

ImageUpload.propTypes = {
  // setImageUrl: PropTypes.func.isRequired,
  // imageUrl: PropTypes.string,
  notifyInfo: PropTypes.func.isRequired,
  notifyFailure: PropTypes.func.isRequired,
  photoType: PropTypes.string.isRequired,
  idPrefix: PropTypes.string.isRequired
};
